var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DateRangePicker", {
    staticClass: "customRangeStyles w-full",
    attrs: {
      "date-range": _vm.value,
      ranges: false,
      "locale-data": _vm.locale,
      "max-date": _vm.maxDateValue,
      "min-date": _vm.minDateValue,
      "single-date-picker": "range",
      opens: "center",
    },
    on: {
      "start-selection": _vm.updateMaxDate,
      update: _vm.handleUpdate,
      select: _vm.handleSelect,
      toggle: _vm.handleToggle,
    },
    scopedSlots: _vm._u([
      {
        key: "footer",
        fn: function ({ clickApply, clickCancel }) {
          return [
            _c(
              "div",
              { staticClass: "flex p-2 justify-end" },
              [
                _c("UiButton", {
                  staticClass: "mr-3",
                  attrs: {
                    variant: "outline",
                    size: "xs",
                    buttonText: "Cancel",
                  },
                  on: { click: clickCancel },
                }),
                _c("UiButton", {
                  attrs: { buttonText: "Apply", size: "xs" },
                  on: { click: clickApply },
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }